export class CurrentExercise {
  exerciseId : number;
  description : string;
  startDate: Date;
  endDate: Date;
}
